import { parse } from 'hub-http/helpers/params';
import { isPreVerification } from '../flow-settings/settingsSelectors';
import PortalIdContainer from '../portal-id-container/PortalIdContainer';
import { getRouteParams } from '../routing/getRouteParams';
import { getHublet } from '../store/app/selectors';
import { updateAuth } from '../store/auth/action-creators';
import TrackerContainer from '../tracking/TrackerContainer';
import checkAuth from './checkAuthApi';
export const setAuthHubless = auth => dispatch => {
  const {
    id: userId,
    email,
    firstName,
    lastName
  } = auth;
  const user = {
    firstName,
    lastName,
    email
  };

  if (isPreVerification()) {
    TrackerContainer.switchToIdentifiableTracker(email);
    TrackerContainer.setProperties({
      namespace: 'signup',
      email,
      userId
    });
  }

  dispatch(updateAuth({
    auth,
    user,
    gates: [],
    portal: {},
    portalId: null,
    userId,
    initialized: true
  }));
  return Promise.resolve({
    email
  });
};
export const setAuth = auth => dispatch => {
  const portalId = PortalIdContainer.get() || auth.hubIds[0];
  const {
    id: userId,
    email,
    firstName,
    lastName
  } = auth;
  const user = {
    firstName,
    lastName,
    email
  };

  if (isPreVerification()) {
    TrackerContainer.switchToIdentifiableTracker(email);
    TrackerContainer.setProperties({
      namespace: 'signup',
      email,
      hubId: portalId,
      userId
    });
  }

  dispatch(updateAuth({
    auth,
    user,
    portalId,
    userId,
    initialized: true
  }));
  return Promise.resolve({
    email
  });
};

const init = () => (dispatch, getState) => {
  const state = getState();
  const hublet = getHublet(state);
  return checkAuth(hublet).then(auth => {
    const {
      hubIds = []
    } = auth;

    if (hubIds.length) {
      PortalIdContainer.set(PortalIdContainer.get() || hubIds[0]);
      dispatch(setAuth(auth));
    } else {
      dispatch(setAuthHubless(auth));
    }

    return auth;
  });
};

export const Auth = {
  init
};
export const getGatesWithUrlOverrides = gates => {
  const {
    gates: overrideGates
  } = parse(getRouteParams().search);

  if (!overrideGates) {
    return gates;
  }

  if (!Array.isArray(overrideGates)) {
    return [...gates, overrideGates];
  }

  return [...gates, ...overrideGates];
};